<script>
import { mapGetters, mapActions } from 'vuex'
import { Canvg, Document } from 'canvg'
import { changeDpiDataUrl } from 'changedpi'
import { LAYOUT } from '@/constants/enum'

export default {
  name: 'showPreview',
  data() {
    return {
      canvas: {
        width: 0,
        height: 0,
        scaleX: 0,
        scaleY: 0,
      },
      logo: null,
      copyright: {
        text: 'MINTIA MY LABEL MAKER',
      },
      stamps: {},
      avatars: {},
      background: null,
      backgroundCopyright: null,
      selectedShapeName: '',
      stageArea: null,
      transformer: null,
    }
  },
  props: {
    selectedName: {
      type: String,
      default: '',
    },
    avatarDraw: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    textDraw: {
      type: Array,
      required: true,
      default: () => [],
    },
    stampDraw: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    currentMove: {
      type: String,
      default: '',
    },
    backgroundDraw: {
      type: Object,
      default: () => ({}),
    },
    enableDrag: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('settings', ['setExportImage', 'saveToStorage']),
    handleDragMove(e) {
      const wrapPosition = this.$refs.stage.$el.getBoundingClientRect()
      const mouseX = e.evt.clientX ? e.evt.clientX : e.evt.touches[0].clientX
      const mouseY = e.evt.clientY ? e.evt.clientY : e.evt.touches[0].clientY
      if (
        mouseX < wrapPosition.x ||
        wrapPosition.x + wrapPosition.width < mouseX ||
        mouseY < wrapPosition.y ||
        wrapPosition.y + wrapPosition.height < mouseY
      ) {
        let newX = e.target.x()
        let newY = e.target.y()

        const mouseOnItemX = mouseX - wrapPosition.x - e.target.x()
        const mouseOnItemY = mouseY - wrapPosition.y - e.target.y()
        if (mouseX < wrapPosition.x) {
          newX = 0 - mouseOnItemX
        }
        if (wrapPosition.x + wrapPosition.width < mouseX) {
          newX = wrapPosition.width - mouseOnItemX
        }
        if (mouseY < wrapPosition.y) {
          newY = 0 - mouseOnItemY
        }
        if (wrapPosition.y + wrapPosition.height < mouseY) {
          newY = wrapPosition.height - mouseOnItemY
        }
        e.target.setAbsolutePosition({
          x: newX,
          y: newY,
        })
      }
    },
    handleDragEnd(e, list, secondData = []) {
      if (!this.enableDrag) {
        return
      }
      let rect = Object.values(list).find(r => r.id === e.target.attrs.name)
      if (rect) {
        rect.x = e.target.x()
        rect.y = e.target.y()
        rect.rotation = e.target.rotation()
        rect.scaleX = e.target.scaleX()
        rect.scaleY = e.target.scaleY()
        if (secondData[e.target.attrs.name]) {
          secondData[e.target.attrs.name].x = e.target.x()
          secondData[e.target.attrs.name].y = e.target.y()
          secondData[e.target.attrs.name].rotation = e.target.rotation()
          secondData[e.target.attrs.name].scaleX = e.target.scaleX()
          secondData[e.target.attrs.name].scaleY = e.target.scaleY()
        }
      }
    },
    handleTransformEnd(e, list) {
      if (!this.enableDrag) {
        return
      }
      const rect = Object.values(list).find(
        r => r.id === this.selectedShapeName
      )
      rect.x = e.target.x()
      rect.y = e.target.y()
      rect.rotation = e.target.rotation()
      rect.scaleX = e.target.scaleX()
      rect.scaleY = e.target.scaleY()
    },
    handleStageMouseDown(e) {
      if (!this.enableDrag) {
        return
      }
      if (!e.evt) {
        return
      }
      if (!this.currentMove) {
        return
      }
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = ''
        this.updateTransformer()
        return
      }
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer'
      if (clickedOnTransformer) {
        return
      }
      const name = e.target.name()
      let rect = Object.values(this.dataDraw).find(r => r.id === name)
      if (rect) {
        this.selectedShapeName = name
      } else {
        this.selectedShapeName = ''
      }
      this.updateTransformer()
    },
    updateTransformer() {
      const transformerNode = this.$refs.transformer.getNode()
      const stage = transformerNode.getStage()
      const { selectedShapeName } = this
      const selectedNode = stage.findOne('.' + selectedShapeName)
      if (selectedNode === transformerNode.node()) {
        return
      }
      if (selectedNode) {
        transformerNode.nodes([selectedNode])
      } else {
        transformerNode.nodes([])
      }
    },
    rotatePoint({ x, y }, deg) {
      const rcos = Math.cos(deg * (Math.PI / 180))
      const rsin = Math.sin(deg * (Math.PI / 180))
      return {
        x: x * rcos - y * rsin,
        y: y * rcos + x * rsin,
      }
    },
    updateTransform(list) {
      const transformerNode = this.$refs.transformer.getNode()
      const stage = transformerNode.getStage()
      const { selectedShapeName } = this
      const selectedNode = stage.findOne('.' + selectedShapeName)

      if (selectedNode) {
        const currentObject = Object.values(list).find(
          item => item.id === selectedShapeName
        )
        if (currentObject) {
          const rad = currentObject.rotation
          const scale = currentObject.scaleX

          if (selectedNode.scaleX() !== scale) {
            currentObject.x = selectedNode.x()
            currentObject.y = selectedNode.y()
            selectedNode.scale({
              x: currentObject.scaleX,
              y: currentObject.scaleY,
            })
          }

          if (selectedNode.rotation() !== rad) {
            selectedNode.rotation(+rad)
          }
        }
      }
      this.updateTransformer()
    },
    calSize(axis = 'x') {
      let x, y

      if (this.getOrientation === LAYOUT.PORTRAID) {
        y = this.$refs.domWrap.clientHeight
        x = (y * 39.996) / 90.006
      } else {
        x = 360
        y = 204
      }

      return axis === 'x' ? x : y
    },
    saveImagePreview() {
      const imageSave = this.$refs.stage.getNode().toDataURL({
        mimeType: 'image/png',
        quality: 1,
        pixelRatio:
          this.getOrientation === LAYOUT.LANDSCAPE
            ? 720 / this.canvas.width
            : 472.4409448818898 / this.canvas.width,
      })

      this.setExportImage(changeDpiDataUrl(imageSave, 300))
      this.saveToStorage()
    },
    choiceTemplate() {
      if (!this.backgroundDraw.src) {
        this.background = null
        this.logo = null
        return
      }

      const imagebg = new window.Image()
      const imagecopyright = new window.Image()

      imagebg.src = this.backgroundDraw.src
      imagecopyright.src = this.backgroundDraw.copyrightImg
      this.backgroundCopyright = imagecopyright

      imagebg.onload = () => {
        this.canvas.scaleX = this.canvas.width / imagebg.width
        this.canvas.scaleY = this.canvas.height / imagebg.height
        this.background = imagebg
      }

      if (this.backgroundDraw.logo) {
        const imageLogo = new window.Image()
        imageLogo.src = this.backgroundDraw.logo

        imageLogo.onload = () => {
          this.logo = imageLogo
        }
      } else {
        this.logo = null
      }
    },
    registerAvatar() {
      for (const avatarId in this.avatarDraw) {
        if (!this.avatars[avatarId]) {
          const canvas = Document.createCanvas(320, 320)
          const ctx = canvas.getContext('2d')

          const v = Canvg.fromString(
            ctx,
            window.atob(this.avatarDraw[avatarId].src),
            {
              offsetY: 0,
              scaleWidth: 320,
            }
          )
          v.resize(270, 320, false)
          v.render()

          if (v.isReady()) {
            this.$set(this.avatars, this.avatarDraw[avatarId].id, {
              image: canvas,
              draggable: true,
              name: avatarId,
              x: this.avatarDraw[avatarId].x || this.canvas.width / 2,
              y: this.avatarDraw[avatarId].y || this.canvas.height / 2,
              rotation: +this.avatarDraw[avatarId].rotation,
              scaleX: +this.avatarDraw[avatarId].scaleX,
              scaleY: +this.avatarDraw[avatarId].scaleY,
              visible: this.avatarDraw[avatarId].show,
              offsetX: 270 / 2,
              offsetY: 320 / 2,
            })
          }
        }
      }
    },
    registerStamp() {
      for (const stampId in this.stampDraw) {
        if (!this.stamps[stampId]) {
          let img = new Image()
          img.src = this.stampDraw[stampId].thumSrc
          img.onload = () => {
            this.$set(this.stamps, this.stampDraw[stampId].id, {
              image: img,
              draggable: true,
              name: stampId,
              x:
                this.stampDraw[stampId].x ||
                (this.stampDraw[stampId].width *
                  this.stampDraw[stampId].scaleX) /
                  2,
              y:
                this.stampDraw[stampId].y ||
                this.canvas.height -
                  (this.stampDraw[stampId].height *
                    this.stampDraw[stampId].scaleY) /
                    2,
              rotation: +this.stampDraw[stampId].rotation,
              scaleX: +this.stampDraw[stampId].scaleX,
              scaleY: +this.stampDraw[stampId].scaleY,
              offsetX: +this.stampDraw[stampId].width / 2,
              offsetY: +this.stampDraw[stampId].height / 2,
            })
          }
        }
      }
    },
    updateAvatarData(newValue) {
      if (
        Object.values(newValue).length === Object.values(this.avatars).length
      ) {
        for (const item in newValue) {
          this.avatars[item].visible = newValue[item].show
          if (!newValue[item].show && item === this.selectedShapeName) {
            this.selectedShapeName = ''
          }
        }
      }
      if (Object.values(newValue).length < Object.values(this.avatars).length) {
        Object.keys(this.avatars).forEach(item => {
          if (!newValue[item]) {
            this.$delete(this.avatars, item)
          }
        })
      }
    },
    updateStampData(newValue) {
      if (Object.values(newValue).length < Object.values(this.stamps).length) {
        Object.keys(this.stamps).forEach(item => {
          if (!newValue[item]) {
            this.$delete(this.stamps, item)
            this.selectedShapeName = ''
          }
        })
      }
    },
  },
  computed: {
    ...mapGetters('settings', [
      'getOrientation',
      'getTemplate',
      'getStamps',
      'getTexts',
      'getAvatars',
    ]),
    konvaConfig() {
      return {
        width: 200,
        height: 200,
      }
    },
    dataDraw() {
      const propsData = {
        text: this.textDraw,
        stamp: this.stampDraw,
        avatar: this.avatarDraw,
      }

      const localData = {
        text: this.getTexts,
        stamp: this.getStamps,
        avatar: this.getAvatars,
      }
      if (this.currentMove == 'all') return {...propsData.text, ...propsData.stamp, ...propsData.avatar }
      return propsData[this.currentMove] || localData[this.currentMove]
    },
  },
  watch: {
    selectedShapeName: {
      handler(value) {
        this.$emit('onchangeSelect', value)
      },
      deep: true,
    },
    avatarDraw: {
      handler(value) {
        this.updateTransform(this.avatarDraw)
        this.updateAvatarData(value)
      },
      deep: true,
    },
    textDraw: {
      handler() {
        this.updateTransform(this.textDraw)
      },
      deep: true,
    },
    backgroundDraw: {
      handler() {
        this.choiceTemplate()
      },
      deep: true,
    },
    selectedName: {
      handler() {
        this.selectedShapeName = this.selectedName
        this.updateTransformer()
      },
      deep: true,
    },
    stampDraw: {
      handler(value) {
        this.updateTransform(this.stampDraw)
        this.updateStampData(value)
      },
      deep: true,
    },
  },
  created() {
    this.choiceTemplate()
  },
  mounted() {
    this.transformer = this.$refs.transformer.getStage()
    this.stageArea = this.$refs.stage.getStage()
    this.canvas = {
      width: this.calSize('x'),
      height: this.calSize('y'),
    }
    this.$refs.stage.getNode().width(this.canvas.width)
    this.$refs.stage.getNode().height(this.canvas.height)
    this.registerStamp()

    this.registerAvatar()

    setTimeout(() => {
      const transformerNode = this.$refs.transformer
      if (transformerNode) {
        transformerNode.getNode().forceUpdate()
      }
    }, 2000)
  },
  beforeUpdate() {
    // this.copyright.x =
    //   this.canvas.width - this.$refs.copyrightMark.getNode().textWidth - 10
    // this.copyright.y =
    //   this.canvas.height - this.$refs.copyrightMark.getNode().textHeight - 5

    this.stageArea.draw()
  },
  updated() {
    const transformerNode = this.$refs.transformer.getNode()
    const stage = transformerNode.getStage()
    this.textDraw.forEach(item => {
      const selectedNode = stage.findOne('.' + item.id)
      selectedNode.position({
        x: item.x || selectedNode.textWidth / 2,
        y: item.y || this.canvas.height - selectedNode.textHeight / 2,
      })
      selectedNode.offset({
        x: selectedNode.textWidth / 2,
        y: selectedNode.textHeight / 2,
      })
    })
  },
}
</script>

<template>
  <div class="preview-component">
    <div :class="`box ${getOrientation}`" ref="domWrap">
      <v-stage
        ref="stage"
        :class="['konva-wrap', { preview: !enableDrag }]"
        :config="konvaConfig"
        @mousedown="handleStageMouseDown"
        @touchstart="handleStageMouseDown"
      >
        <v-layer>
          <v-image
            :config="{
              x: 0,
              y: 0,
              image: background,
              scaleX: canvas.scaleX,
              scaleY: canvas.scaleY,
              listening: false,
            }"
          />
          <v-image
            v-for="(avatar, idx) of avatars"
            :key="`avatarc${idx}`"
            :config="avatar"
            @transformend="handleTransformEnd($event, avatars)"
            @dragend="handleDragEnd($event, avatarDraw, avatars)"
            @dragmove="handleDragMove($event)"
          />
          <v-image
            v-for="(stamp, idx) of stamps"
            :key="`stamp${idx}`"
            :config="stamp"
            @transformend="handleTransformEnd($event, stamps)"
            @dragend="handleDragEnd($event, stampDraw, stamps)"
            @dragmove="handleDragMove($event)"
          />
          <v-text
            v-for="(item, idx) of textDraw"
            :key="`text${idx}`"
            :config="{
              text: item.text,
              fontSize: 25,
              fill: item.color,
              fontFamily: item.fontFamily,
              name: item.id,
              fontStyle: '100',
              rotation: +item.rotation,
              scaleX: +item.scaleX,
              scaleY: +item.scaleY,
              draggable: enableDrag,
            }"
            @transformend="handleTransformEnd($event, textDraw)"
            @dragend="handleDragEnd($event, textDraw)"
            @dragmove="handleDragMove($event)"
          />
          <v-image
            v-if="logo"
            :config="{
              x: 0,
              y: 0,
              scaleX: canvas.scaleX,
              scaleY: canvas.scaleY,
              image: logo,
              listening: false,
            }"
          />1
          <v-image
            v-if="getOrientation == 'landscape'"
            :config="{
              x: canvas.width - 85,
              y: canvas.height - 10,
              image: backgroundCopyright,
              scaleX: 0.35,
              scaleY: 0.35,
              listening: false,
            }"
          />
          <v-image
            v-else
            :config="{
              x: canvas.width - 104,
              y: canvas.height - 11,
              image: backgroundCopyright,
              scaleX: 0.35,
              scaleY: 0.35,
              listening: false,
            }"
          />
          <v-transformer
            ref="transformer"
            :config="{
              borderStroke: '#FE0000',
              rotateEnabled: false,
              enabledAnchors: [],
              opacity: 1,
              padding: 2,
              centeredScaling: true,
            }"
          />
        </v-layer>
      </v-stage>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './sticker-preview.scss';
</style>
